import { application } from '@core/controllers/app';

application.register('plugins-kibana--dashboard', require('./plugins_kibana/dashboard_controller').default);
